import React, { memo } from 'react';
import { MotifAvatar } from '@ey-xd/motif-react';

interface AvatarProps {
    userName?: string;
    src?: string;
    description?: string;
    className?: string;
    size?: string;
    status?: string;
}

const Avatar = ({ src, userName, className, description, size, status = '' }: AvatarProps) => {
    return (
        <MotifAvatar
            className={className}
            userName={userName?.trim()}
            src={src}
            description={description}
            size={size}
            status={status}
        />
    );
};

export default memo(Avatar);
